import {Record as record} from 'immutable';

export default record(
    {
        reviewCount: null,
        averageRating: null,
        ownershipTransferred: false,
        reviews: [],
        isFetching: false,
        isFetchingTranslatedReviews: false,
        previewCount: 3,
        reviewId: '',
        scrollTop: false,
        pageIndex: 1,
        prevPageIndex: 1,
        errorFetchingReviews: false,
        errorTranslatingReviews: false,
        translatedReviewsByUuid: {},
        isTranslationToggleOn: false
    },
    'ReviewsRecord'
);
